export const baseProductQuery = `query {
  allBaseProducts(first: "100") {
    sku
    baseSku
    pageMode
    icon
    name
  }
}`
